// Keep this module free of React imports: server components reach it through
// `@/global/utils` (analytics-events).
import { SKIP_COOKIE_CONSENT } from './skipCookieConsent'

const hasAccepted = (category?: string) => {
  if (typeof window === 'undefined') return false

  try {
    const state = window.CookieScript?.instance?.currentState()
    if (state?.action !== 'accept') return false
    if (category === undefined) return true

    return (
      Array.isArray(state.categories) && state.categories.includes(category)
    )
  } catch {
    return false
  }
}

// Unlike the hook, reads the live state on every call: a revocation takes effect.
const hasCookieConsent = (category: string) =>
  SKIP_COOKIE_CONSENT || hasAccepted(category)

export { hasAccepted, hasCookieConsent }
